import { render, staticRenderFns } from "./CrearAdmision.vue?vue&type=template&id=7a34d019"
import script from "./CrearAdmision.vue?vue&type=script&lang=js"
export * from "./CrearAdmision.vue?vue&type=script&lang=js"
import style0 from "./CrearAdmision.vue?vue&type=style&index=0&id=7a34d019&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports